import { AnimatePresence } from 'motion/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from 'styled-components'

import { openSplashPointsInfoFlowEvent } from '@root/entities/splash-point'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { SplashPointsInfo } from './splash-points-info'

import type { CurrencyModel } from '@root/entities/currency'

export const SplashPointsInfoDialog: React.FC = () => {
  const { t } = useTranslation()
  const [currency, setCurrency] = useState<CurrencyModel | undefined>(undefined)

  openSplashPointsInfoFlowEvent.onCall((_, __, [currency]) =>
    setCurrency(currency),
  )

  return (
    <AnimatePresence>
      {currency ? (
        <PremiumDialog
          open
          onOpenChange={() => setCurrency(undefined)}
          onClose={() => setCurrency(undefined)}
          describedBy={t('splash-points.doc-title')}
          title={t('splash-points.doc-title')}
          css={css`
            width: 580px;
            min-height: 601px;
          `}
        >
          <SplashPointsInfo currency={currency} />
        </PremiumDialog>
      ) : undefined}
    </AnimatePresence>
  )
}
